import { getCoreRowModel, getFilteredRowModel, getSortedRowModel, useReactTable, type ColumnDef, type SortingState, type VisibilityState } from "@tanstack/react-table";
import type { CardType } from "../type";
import type { Dispatch, SetStateAction } from "react";



export const useTableDataColumn = (data : CardType[], columns : ColumnDef<CardType>[], setSorting:Dispatch<SetStateAction<SortingState>>, setColumnVisibility:Dispatch<SetStateAction<VisibilityState>>, globalFilter : string, sorting:SortingState, columnVisibility:VisibilityState) => {
  return useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    state: {
      globalFilter,
      sorting,
      columnVisibility,
    },
  });
};
